import {
  faCircleInfo,
  faIdBadge,
  faUser,
  faBullseye,
  faLayerGroup,
  faCalendarDays,
  faTowerCell,
  faSignal,
  faCalendarPlus,
  faHandshake,
  faCirclePause,
  faCircleCheck,
  faArrowsToEye,
  faRectangleAd,
  faPen,
  faFolderOpen,
  faSquarePlus,
  faClock,
  faThumbsUp,
  faArrowsSpin,
  faRotateRight,
  faMagnifyingGlass,
  faCheck,
  faBookmark,
  faPlus,
  faMinus,
  faTimes,
  faSort,
  faSortUp,
  faSortDown,
  faCopy,
} from '@fortawesome/free-solid-svg-icons';

export default [
  faCircleInfo,
  faIdBadge,
  faUser,
  faBullseye,
  faLayerGroup,
  faCalendarDays,
  faTowerCell,
  faSignal,
  faCalendarPlus,
  faHandshake,
  faCirclePause,
  faCircleCheck,
  faArrowsToEye,
  faRectangleAd,
  faPen,
  faFolderOpen,
  faSquarePlus,
  faClock,
  faThumbsUp,
  faArrowsSpin,
  faRotateRight,
  faMagnifyingGlass,
  faCheck,
  faBookmark,
  faPlus,
  faMinus,
  faTimes,
  faSort,
  faSortUp,
  faSortDown,
  faCopy,
];
